/**
 * Note: This is consumed both client and server side.
 */

/**
 * Public Routes
 *
 * Use this to define any public routes that do not
 * require authentication.
 */
export const publicRoutes = [
  // Auth js routes
  '/api/auth/error',
  '/api/auth/signin',
  '/api/auth/signout',
  '/api/auth/providers',
  // Custom routes
  '/survey-complete',
  '/signed-out',
  '/api/auth/step-up/password-changed',
]
